import React from 'react';
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';
// import './Header2.scss';
// import Particles from '../../components/Particles';

const scaleVariants = {
  whileInView:{
    scale: [0,1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>

      {/* this i made for my name*/}
      <motion.div 
        whileInView={ { x : [-100, 0], opacity: [0,1]}}
        transition = {{duration: 0.5}}
        className='app__header-info'
      >

        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span> 👋 </span>
            <div style =  {{marginLeft: 20}}>
              <p className='p-text helloiam' > Hello, I am </p>
              {/* <h6 className=''> Hello, I am </h6> */}
              <h1 className='head-text'>Naman</h1>

            </div>
          </div>
        

          <div className='tag-cmp app_flex'>
          <p className='p-text'>I am a full stack developer and UI/UX designer aimed at combining creative thinking & design with an analytical approach to solve problems for the mass.</p>
          {/* <p className='p-text'>UX Designer</p> */}
        </div>
        </div>
        
      </motion.div >

      {/* this i made for circle behind me*/}
      <motion.div
        whileInView={ { opacity: [0,1]}}
        transition = {{duration: 0.5, delayChildren: 0.5}}
        className='app__header-img'
      >
        <img src = {images.profile} alt ='profile_bg'></img>
        {/* <motion.img
          whileInView={ { scale: [0,1]}}
          transition = {{duration: 1, ease: 'easeInOut'}}
          className='overlay_circle'
          src = {images.circle}
          alt = 'profile_circle'
          
        /> */}

      </motion.div>
        

      {/* this i made for langauages floating at back*/}  
      <motion.div
        variant = {scaleVariants}
        whileInView = {scaleVariants.whileInView}
        className='app__header-circles'
      >

        {[images.figma, images.mu5, images.react,images.nodejs,images.redux].map((circles,index) => 
          <div className='circle-cmp app__flex' key = {`circle-${index}`}>
            <img src = {circles} alt = 'circle'/>
          </div>
        )}

      </motion.div>
      {/* <div app__header-bgdesign>
        <Particles id="tsparticles" />
      </div> */}
    </div>
  )
}

export default AppWrap(Header, 'home');
